import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

import { DEFAULT_LOCALE } from '@/constants';

export const dateFormat = 'L';
export const timeFormat = 'LT';

let formatMessage = null;
let locale = DEFAULT_LOCALE;

export function updateIntl(theLocale, theFormatMessage) {
    formatMessage = theFormatMessage;
    locale = theLocale;
}

export function getLocale() {
    return locale;
}

export function getFormatMessage() {
    return formatMessage;
}

// eslint-disable-next-line max-statements
export function formatDateTime(inputDate) {
    if (isEmpty(inputDate) || !moment(inputDate.valueOf()).isValid()) {
        return null;
    }

    const date = moment(inputDate.valueOf());

    date.locale(getLocale());
    const prefix = date.format(dateFormat);
    return `${prefix}, ${date.format(timeFormat)}`;
}
